import React from 'react';
import _constants from '../constants';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _constants2 = _interopRequireDefault(_constants);

function Container(_ref) {
  var children = _ref.children;
  var clearfix = _ref.clearfix;
  var gutter = typeof _ref.gutter === 'number' ? _ref.gutter : _constants2['default'].width.gutter;
  var maxWidth = typeof _ref.maxWidth === 'number' ? _ref.maxWidth : _constants2['default'].width.container;
  var style = _ref.style;

  var props = _objectWithoutProperties(_ref, ['children', 'clearfix', 'gutter', 'maxWidth', 'style']);

  var styles = {
    clearfix: {
      clear: 'both',
      display: 'table'
    },
    container: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: maxWidth,
      paddingLeft: gutter,
      paddingRight: gutter,
    }
  };
  props.style = _extends({}, styles.container, style);

  return React.createElement(
    'div',
    props,
    clearfix && React.createElement('span', { style: styles.clearfix }),
    children,
    clearfix && React.createElement('span', { style: styles.clearfix })
  );
};

export default Container;